import { useRef, useState } from 'react';
import '../App.css';
import Table from './Table';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';
import { aplicarMascaraCpfCnpj } from '../utils/MaskUtils';
import { handleErrors, request } from '../utils/ApiUtils';

import Button from '@mui/material/Button';
import Input from './Input';
import { getUserLogged } from '../utils/TokenUtils';
import { showNotification } from '../utils/NotificationUtils';
import { FaUsers } from 'react-icons/fa';

function Clientes() {
    const navigate = useNavigate();

    const [filter, setFilter] = useState('');
    const [pageData, setPageData] = useState({});
    const [dataArray, setDataArray] = useState([]); 
    const firstRender = useRef(0);
    const [fetchListError, setFetchListError] = useState();
    const [refreshKey, setRefreshKey] = useState(0);
    const [loading, setLoading] = useState({loading: false});


    const triggerRefresh = () => setRefreshKey((prev) => prev + 1);

    const carregarDados = async (page = 0) => {
        setLoading({loading: true});

        request(`clientes/paginated?page=${page}&query=${filter || ''}`, {
            type: 'POST',
            body: JSON.stringify({}),
            callback: (data) => {
                setPageData(data);
                setDataArray(data.content);
            },
            callbackError: (responseData, message) => { handleErrors(responseData, 'Falha ao buscar clientes: '+message, {setFetchListError}) },
            finally: () => setLoading({loading: false})
        })
    };


    useEffect(() => { carregarDados(); }, []);

    useEffect(() => { 
        if (firstRender.current < 1) {
            firstRender.current = firstRender.current+1;
            return;
        }
        carregarDados(0); 
    }, [filter]);

    const salvarCliente = async (cliente) => {
        cliente.usuarioUltimaAlteracao = getUserLogged();

        const method = cliente.id ? "PUT" : "POST";
        const url = cliente.id ? `clientes/${cliente.id}` : "POST";

        request(url, {
            type: method,
            body: JSON.stringify({ ...cliente, ativo: !cliente.ativo }),
            callback: (data) => {
                cliente.ativo = !cliente.ativo
                showNotification('Cliente alterado', 'success');
            },
            callbackError: (responseData, message) => {
                responseData?.error ?
                    showNotification(responseData.error, 'error') :
                    showNotification('Não foi possível alterar o cliente, revise o cadastro.', 'error');

            },
            finally: () => {
                triggerRefresh()
            }
        })
    };


    const tableParams = {
        query: (page) => carregarDados(page),
        triggerRefresh: triggerRefresh,
        columns: [
            {
                label: "Documento",
                width: "15%",
                type: "input",
                key: "documento",
                disable: true,
                getValue: (item) => aplicarMascaraCpfCnpj(item.documento)
            },
            {
                label: "Nome / Razão social",
                width: "25%",
                type: "input",
                key: "nome",
                disable: true,
                getValue: (item) => item.nome
            },
            {
                label: "Cidade",
                width: "20%",
                type: "input",
                disable: true,
                key: "endereco.cidade",
                getValue: (item) => item?.endereco?.cidade || ''
            },

            {
                label: "UF",
                width: "10%",
                type: "input",
                disable: true,
                key: "endereco.uf",
                getValue: (item) => item?.endereco?.uf || ''
            },

            {
                label: "Ativo",
                width: "5%",
                type: "checkbox",
                disabled: true,
                key: "ativo",
                getValue: (item) => item.ativo,
                onClick: (item) => {
                    salvarCliente(item);
                }
            },
            {
                label: "Editar",
                width: "5%",
                type: "button-icon",
                css: "button",
                icon: (<VisibilityIcon />),
                onClick: (cliente) => navigate(`/clientes/cadastro/${cliente.id}`)
            }
        ]
    };

    return (
        <div className="form-container list-page">


            <div id="notification-container" className='notification-container' style={{
                position: "fixed",
                display: "flex",
                justifyContent: "flex-end",
                flexWrap: "wrap-reverse",
                alignItems: "flex-end",
                top: "0", // Aqui muda pra aparecer no topo
                right: "30px",
                maxHeight: "100vh",
                zIndex: 9999
            }}></div>


            <div className="header-container">
                <div className="page-title-content">
                    <FaUsers aria-hidden="true" />
                    <h1 style={{ color: 'black' }}>Clientes</h1>
                </div>
               <Button className="new-contract-button" variant="contained" onClick={() => navigate(`/clientes/cadastro`)} >
                    Novo cliente
                </Button>
                {/* <Button variant="text" onClick={() => navigate(`/clientes/cadastro`)} startIcon={(<AddIcon style={{ fontSize: '2rem', fontWeight: 'bold', color:'#0057a3' }} />)} /> */}
            </div>

            <div className='row'>

                <Input id="filtro"
                    parameters={{
                        width: '30%', label: "Filtre por nome ou documento ", onChange: (value) => {
                            setFilter(value);
                        }
                    }} />
            </div>

            <Table params={tableParams} dataArray={dataArray} pageData={pageData} filter={filter} refreshKey={refreshKey} loading={loading} errorOccurred={fetchListError} />
        </div>
    );
}

export default Clientes;
